module.exports = __webpack_public_path__ + "img/9791186294079.5db74503.jpg";